import { CheckCircleIcon } from "@phosphor-icons/react";

import { Heading } from "../../../../../../components/v2";
import { BALANCES_STRINGS } from "../../constants/strings";
import { IMPORT_OPTION_ID } from "../../constants/importOptions";
import { SYSTEM_NAME } from "shared/constants/externalSystems";

const loadingOptions = [
  {
    id: IMPORT_OPTION_ID.BASE_SYSTEM,
    title: BALANCES_STRINGS.OPTION_BASE_SYSTEM_TITLE,
    description: BALANCES_STRINGS.OPTION_BASE_SYSTEM_DESCRIPTION,
  },
  {
    id: IMPORT_OPTION_ID.TEMPLATE,
    title: BALANCES_STRINGS.OPTION_TEMPLATE_TITLE,
    description: BALANCES_STRINGS.OPTION_TEMPLATE_DESCRIPTION,
  },
];

const LoadOption = ({ title, description, isSelected, onSelect }) => {
  return (
    <button
      type="button"
      aria-pressed={isSelected}
      className={`flex flex-col w-[calc(50%-0.5rem)] px-2 pb-2 border rounded-2xl text-left relative transition-colors ${isSelected ? "border-secondary-PCS001 bg-secondary-PCS001/5" : "border-gray-300"}`}
      onClick={onSelect}
    >
      {isSelected && (
        <CheckCircleIcon
          aria-hidden={true}
          size={24}
          weight="fill"
          className="absolute -right-[0.7rem] -top-[0.7rem] text-secondary-PCS001 bg-white rounded-full"
        />
      )}
      <Heading
        level={3}
        className={`${isSelected ? "text-secondary-PCS001" : "text-gray-900"}`}
      >
        {title}
      </Heading>
      <p className="text-sm text-secondaryText">{description}</p>
    </button>
  );
};

const OptionSelectionStep = ({ selectedOption, onSelect, baseSystemName }) => {
  return (
    <div className="flex flex-col w-full p-2 gap-4">
      <p className="text-secondaryText">
        {BALANCES_STRINGS.OPTION_SELECTION_DESCRIPTION}
      </p>
      <fieldset className="flex justify-center gap-4 border-none p-0 m-0">
        <legend className="sr-only">Método de importación</legend>
        {loadingOptions
          .filter(
            (option) =>
              !(
                option.id === IMPORT_OPTION_ID.BASE_SYSTEM &&
                baseSystemName === SYSTEM_NAME.NOMINAS
              ),
          )
          .map((option) => (
            <LoadOption
              key={option.id}
              title={option.title.replaceAll(
                "[system]",
                baseSystemName ?? "sistema base",
              )}
              description={option.description}
              isSelected={selectedOption === option.id}
              onSelect={() => onSelect(option.id)}
            />
          ))}
      </fieldset>
    </div>
  );
};

export default OptionSelectionStep;
